/*
  Memoria del visitante — Soulbike / ANT Digital

  Guarda en el navegador qué miró la persona para poder armarle el sitio con eso:
  las últimas fichas vistas, la marca y el tipo que más repite, y la talla que
  eligió. Todo vive en localStorage, es por navegador y nunca sale del equipo:
  no hay login, no hay cookie de terceros y no viaja ningún dato al servidor.

  Cada lectura y escritura va en try/catch porque en ventana privada, con las
  cookies bloqueadas o durante la captura de miniaturas, localStorage puede
  tirar excepción o volver vacío. Si falla, el sitio sigue funcionando igual.
*/
(function () {
  'use strict';

  var LLAVE = 'sb_memoria_v1';
  var TOPE = 12;

  function leer() {
    try {
      var cru = localStorage.getItem(LLAVE);
      if (!cru) return { vistas: [] };
      var d = JSON.parse(cru);
      return d && Array.isArray(d.vistas) ? d : { vistas: [] };
    } catch (e) {
      return { vistas: [] };
    }
  }

  function guardar(d) {
    try { localStorage.setItem(LLAVE, JSON.stringify(d)); } catch (e) {}
  }

  /* Registra una ficha vista. Mueve al frente si ya estaba, para no duplicar. */
  function registrar(p) {
    if (!p || !p.handle) return;
    var d = leer();
    var vistas = d.vistas.filter(function (x) { return x.handle !== p.handle; });
    p.visto = Date.now();
    vistas.unshift(p);
    d.vistas = vistas.slice(0, TOPE);
    guardar(d);
  }

  /* Guarda la talla recién elegida sobre la ficha que ya está registrada. */
  function recordarTalla(handle, talla) {
    if (!handle || !talla) return;
    var d = leer();
    for (var i = 0; i < d.vistas.length; i++) {
      if (d.vistas[i].handle === handle) { d.vistas[i].talla = talla; break; }
    }
    guardar(d);
  }

  /*
    Resume lo visto. Lo más reciente pesa más: la primera visita de la lista
    vale tanto como el largo de la lista y va bajando. Así una sesión nueva
    manda sobre lo que miró hace una semana, sin borrar el historial.
  */
  function perfil() {
    var vistas = leer().vistas;
    var tipos = {}, marcas = {}, tallas = {};

    vistas.forEach(function (x, i) {
      var peso = vistas.length - i;
      if (x.tipo)  tipos[x.tipo]   = (tipos[x.tipo]   || 0) + peso;
      if (x.marca) marcas[x.marca] = (marcas[x.marca] || 0) + peso;
      if (x.talla) tallas[x.talla] = (tallas[x.talla] || 0) + 1;
    });

    function mayor(o) {
      var k = Object.keys(o);
      if (!k.length) return null;
      return k.sort(function (a, b) { return o[b] - o[a]; })[0];
    }

    return {
      vistas: vistas,
      tipo:   mayor(tipos),
      marca:  mayor(marcas),
      talla:  mayor(tallas),
      total:  vistas.length
    };
  }

  function olvidar() {
    try { localStorage.removeItem(LLAVE); } catch (e) {}
  }

  window.SBMemoria = {
    registrar: registrar,
    recordarTalla: recordarTalla,
    perfil: perfil,
    leer: leer,
    olvidar: olvidar
  };
})();
